import QuoteEntity from './QuoteEntity'

export default QuoteEntity
